<div class="mb-6 flex flex-wrap items-center justify-between gap-4">
  <div>
    <h1 class="!mt-0 !mb-2">Auto Molds</h1>
    <p class="!mt-0 text-muted-color">
      Create and manage automated mold flows.
    </p>
  </div>
  <p-button label="New Auto Mold" icon="pi pi-plus" (onClick)="newItem()" />
</div>

@if (error(); as message) {
  <p-message severity="warn" [text]="message" class="mb-4 block" />
}

<div class="rounded-xl border border-surface-switch-200 shadow-sm">
  <!-- Header Row -->
  <div
    class="hidden lg:grid lg:grid-cols-4 rounded-t-xl bg-surface-switch-100 items-center gap-4 p-4 text-sm font-bold text-surface-switch-600 uppercase"
  >
    <div>Auto Mold ID</div>
    <div>Name</div>
    <div>Creator</div>
    <div class="text-center">Actions</div>
  </div>

  @if (isLoading()) {
    <div class="text-center text-muted-color py-6">Loading...</div>
  } @else if (items().length > 0) {
    <div class="flex flex-col">
      @for (item of items(); track item.id) {
        <div
          class="border border-surface-switch-200 bg-surface-switch-50 transition-colors duration-200 hover:bg-surface-switch-100 cursor-pointer lg:p-4"
          (click)="openFlow(item.id)"
        >
          <!-- Mobile Layout -->
          <div class="lg:hidden p-4 flex flex-col gap-2">
            <div class="flex justify-between items-center">
              <span class="font-semibold text-lg">AM-{{ item.id }}</span>
              <p-button
                icon="pi pi-trash"
                severity="danger"
                [text]="true"
                (onClick)="confirmDeleteItem(item, $event)"
                (click)="$event.stopPropagation()"
                pTooltip="Delete"
                tooltipPosition="top"
              />
            </div>
            <div class="text-sm text-muted-color">
              {{ item.name }}
            </div>
            <div class="text-sm text-muted-color">
              {{ item.creator_email || "—" }}
            </div>
          </div>

          <!-- Desktop Layout -->
          <div
            class="hidden lg:grid lg:grid-cols-4 lg:items-center lg:gap-4 lg:w-full"
          >
            <div class="font-semibold">AM-{{ item.id }}</div>
            <div class="truncate font-semibold text-surface-switch-600">
              {{ item.name }}
            </div>
            <div class="text-sm text-muted-color truncate">
              {{ item.creator_email || "—" }}
            </div>
            <div class="text-center">
              <p-button
                icon="pi pi-trash"
                severity="danger"
                [text]="true"
                (onClick)="confirmDeleteItem(item, $event)"
                (click)="$event.stopPropagation()"
                pTooltip="Delete"
                tooltipPosition="top"
              />
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="text-center text-muted-color py-6">
      No auto molds found. Create one to get started.
    </div>
  }
</div>

<shared-confirm-dialog />
